import PropTypes from "prop-types";
import getAfsFulfilmentStrings from "../getAfsFulfilmentStrings";

const AfsFulfilmentStringsMarkup = ({ labelledById, seller }) => {
  const { afs_sold_by, sellerDescription, afs_shipped_by_asos } =
    getAfsFulfilmentStrings({ seller });

  return (
    <span id={labelledById} aria-hidden={true}>
      {afs_sold_by} <strong>{sellerDescription}</strong>
      {afs_shipped_by_asos}
    </span>
  );
};

AfsFulfilmentStringsMarkup.propTypes = {
  labelledById: PropTypes.string.isRequired,
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
};

export default AfsFulfilmentStringsMarkup;
